import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ImageSuiteHistoryItem } from "../../../ImageSuite/ImageSuiteHistory/Components/ImageSuiteHistoryItem";
import { ImageSuiteApps } from "../../../../Helper";
import { DisplayHistoryItemDataModal } from "../../../ImageSuite/ImageSuiteHistory/Components/DisplayHistoryItemDataModal";
import { ImageLibraryItem } from "../../InspirationLibraryHelper";
import { VideoDetailsView } from "../../../VideoSuite/Components/Shared/VideoSuiteHelper";
import { useNavigate } from "react-router-dom";

interface ImageLibraryItemsProps {
  activeCategory: number;
  imageLibraryItems: ImageLibraryItem[];
}

export const ImageLibraryItems = ({
  activeCategory,
  imageLibraryItems,
}: ImageLibraryItemsProps) => {
  const navigate = useNavigate();
  const [selectedImageLibrary, setSelectedImageLibrary] =
    useState<ImageLibraryItem | null>(null);
  const [openImageLibraryItemModal, setOpenImageLibraryItemModal] =
    useState(false);

  const handleOpenImageLibraryModal = () => {
    setOpenImageLibraryItemModal(true);
  };

  const handleCloseImageLibraryModal = () =>
    setOpenImageLibraryItemModal(false);

  const handleSelectImageLibrary = (imageItem: ImageLibraryItem) => {
    setSelectedImageLibrary(imageItem);
  };

  // Intersection Observer to add fade-up scroll animation effect.
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [activeCategory, imageLibraryItems]);

  const handleNavigateToItemApp = () => {
    navigate("/suites/image-suite", {
      state: {
        activeImageAppData: selectedImageLibrary,
        activeImageAppType: ImageSuiteApps.ImageGenerator,
      },
    });
  };

  return (
    <>
      <Box className="library-items">
        <Box className="library-items-container">
          <div className="masonry-grid">
            {imageLibraryItems?.map((image, i) => (
              <div
                key={i}
                className="masonry-item fade-up"
                onClick={() => handleSelectImageLibrary(image)}
              >
                <ImageSuiteHistoryItem
                  imageAppItem={{
                    id: "",
                    input: {
                      prompt: image.prompt,
                      imageUrl: image.url,
                    },
                    output: image.url,
                    appId: "",
                    appType: ImageSuiteApps.ImageGenerator,
                    createdAt: "",
                    settings: {
                      model: "Flux",
                      dimension: "1:1",
                      seed: null,
                    },
                    inputType: 0,
                    outputType: 0,
                  }}
                  DeleteImageItem={() => {}}
                  isImageItemDeleted={false}
                  isDeleteImageItemLoading={false}
                  handleCloseDisplayItemModal={handleCloseImageLibraryModal}
                  handleActiveHistoryItem={handleOpenImageLibraryModal}
                  showImageOptions={{
                    download: false,
                    delete: false,
                    share: false,
                  }}
                  cardView={VideoDetailsView.library}
                />
              </div>
            ))}
          </div>
        </Box>
      </Box>
      {openImageLibraryItemModal && (
        <DisplayHistoryItemDataModal
          open={openImageLibraryItemModal}
          itemId=""
          handleClose={handleCloseImageLibraryModal}
          handleRegenerateItem={handleNavigateToItemApp}
          isRegenerateItemLoading={false}
          regenerateItemOutput=""
          suggestionsImageApps={[]}
          imageLibraryData={selectedImageLibrary}
          modalView={VideoDetailsView.library}
        />
      )}
    </>
  );
};
